import React from 'react';

import { Button } from '@components/common';

import { ConfirmationIcon } from '../ConfirmationIcon';

interface Props {
  t: (key: string) => string;
  page: string;
  participation: Participation | null;
  account: PublicGQAccount;
  handleStartClick: () => void;
}

const DefaultLayout: React.FC<Props> = ({ t, page, participation, account, handleStartClick }) => (
  <div id='step-done' key='done' className='tablet:mb-48 my-8 rounded-sm border border-gray-200 p-10 text-center'>
    <ConfirmationIcon className='mx-auto' />
    <h2 role='alert' aria-live='assertive' className='text-custom-brand py-2 text-2xl font-bold'>
      {t(`${page}.heading`)}
    </h2>
    <div className='text-custom-brand pb-8'>{t(`${page}.text`)}</div>
    {participation?.status === 'requested' && (
      <Button onClick={handleStartClick} noStyle className='btn-custom-brand'>
        {t(`${page}.cta`)}
      </Button>
    )}
    {['booked', 'completed'].includes(participation?.status || '') && participation?.external_completion_url && (
      <div className='mt-6 border-t border-gray-200 pt-6'>
        <div className='pb-8 font-bold text-gray-700'>{t('completion_code.heading')}</div>
        <Button href={`${participation.external_completion_url}`} target='_blank'>
          {t('completion_code.submit')}
        </Button>
      </div>
    )}
    {participation?.consent_token && !account.hide_global_opt_out_candidate_ux && (
      <div className='mt-6 border-t border-gray-200 pt-6'>
        <div className='text-custom-brand pb-8 font-bold'>{t('hearing_from_us')}</div>
        <Button href={`/my_preferences/${participation.consent_token}`} noStyle className='btn-custom-brand-secondary'>
          {t('update_contact_preferences')}
        </Button>
      </div>
    )}
  </div>
);

export default DefaultLayout;
